import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createDepartment,
  destroyDepartment,
  updateDepartment,
  fetchDepartments,
} from "../api/department";
import produce from "immer";

const initialState = {
  isLoading: false,
  error: false,
  errors: null,
  department: {},
  data: [],
  currentCount: 0,
  totalCount: 0,
  newCount: 0,
};

export const initialController = {
  filters: [],
  page: 0,
  query: "",
  sort: "desc",
  sortBy: "created_at",
  view: "all",
};

export const updateDepartmentAsync = createAsyncThunk(
  "departments/updateDepartmentAsync",
  async (payload) => {
    let response = await updateDepartment(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const createDepartmentAsync = createAsyncThunk(
  "departments/createDepartmentAsync",
  async (payload) => {
    let response = await createDepartment(payload);

    // If errors, reject and return response
    if (response.error) return false;

    // If all good, return response.
    return response;
  }
);

export const getDepartmentsAsync = createAsyncThunk(
  "cases/getDepartmentsAsync",
  async (controller = initialController, { rejectWithValue }) => {
    // if (! controller) return false;
    let response = await fetchDepartments(controller);
    // If errors, reject and return response
    if (response.response?.status?.match(/404|500|401/))
      return rejectWithValue(true);

    // If all good, return response.
    return response;
  }
);

const departmentSlice = createSlice({
  name: "departments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDepartmentsAsync.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getDepartmentsAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.currentCount = action.payload.currentCount;
        state.newCount = action.payload.newCount;
      })

      .addCase(getDepartmentsAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = [
          "Something went wrong when trying to fetch Departments....is controller missing?",
        ];
      })
      .addCase(updateDepartmentAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateDepartmentAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          const index = draftState.data.findIndex(
            (type) => type.id === action.payload.id
          );
          draftState.data[index] = action.payload;
          draftState.isLoading = false;
        });
      })
      .addCase(updateDepartmentAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update product."];
      })
      .addCase(createDepartmentAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createDepartmentAsync.fulfilled, (state, action) => {
        return produce(state, (draftState) => {
          draftState.data.push(action.payload);
          draftState.isLoading = false;
        });
      })
      .addCase(createDepartmentAsync.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errors = ["Something went wrong when trying to update product."];
      });
  },
});

export const { reducer } = departmentSlice;

export default departmentSlice;
